import Person from "@material-symbols/svg-500/rounded/person.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const PersonIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Person });
	return <Icon />;
};

export default memo(PersonIcon);
